import { clone } from 'lodash';

export class Segment {
  // The API exposes the segment slug as `id`.
  id: string;
  name: string;
  consumer_count: number;

  constructor(payload: Object = {}) {
    Object.assign(this, payload);
  }
}

export function fromApi(data) {
  data = clone(data);

  return data;
}

export function toApi(data) {
  data = clone(data);

  return data;
}

